import { render } from "./DevicesBlock.vue?vue&type=template&id=9adaa91a&scoped=true"
import script from "./DevicesBlock.vue?vue&type=script&lang=js"
export * from "./DevicesBlock.vue?vue&type=script&lang=js"

import "./DevicesBlock.vue?vue&type=style&index=0&id=9adaa91a&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./DevicesBlock.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9adaa91a"]])

export default __exports__